import React from "react";

import { Heading,Text, TextProps } from "@catchoftheday/cg-components";

import { px } from "../../utils";

export const Title = (props: TextProps) => {
  return (
    <Heading.h5
      fontWeight={600}
      fontSize="sm"
      textTransform="uppercase"
      marginBottom="10px"
      marginTop="0px"
      color="#222222"
      {...props}
    />
  );
};

const BaseText = (props: TextProps) => {
  return <Text lineHeight={1.4} color="#333333" {...props} />;
};

export const Body = (props: TextProps) => {
  return <BaseText fontSize={px(14)} {...props} />;
};
